import React from 'react';
import { NavLink } from 'react-router-dom'; // NavLink untuk active state
import './Layout.css';
import { useAuth } from '../../context/AuthContext';

function Sidebar() {
  const { user } = useAuth(); // Dapatkan data user dari context

  return (
    <aside className="app-sidebar">
      <nav>
        <ul>
          <li><NavLink to="/dashboard" end>Dashboard Overview</NavLink></li>
          <li><NavLink to="/dashboard/missions">Manajemen Misi</NavLink></li>
          <li><NavLink to="/dashboard/vouchers">Manajemen Voucher</NavLink></li>
          <li><NavLink to="/dashboard/events">Manajemen Event</NavLink></li>
          <li><NavLink to="/dashboard/reports/users">Laporan Pengguna</NavLink> {/* <-- TAMBAHKAN LINK INI */}</li>
           {user && user.role === 'super-admin' && (
          <>
            <hr /> 
            <div className="sidebar-heading">Admin Area</div>
            <NavLink to="/dashboard/admins">Manajemen Admin</NavLink>
          </>
        )}
          {/* Tambahkan link navigasi lain di sini */}
        </ul>
        
      </nav>
    </aside>
  );
}

export default Sidebar;